import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import moment from 'moment'
import {
   Table, Menu, Dropdown,
   Segment, Input, Pagination,
   Message, Form, Select, Button, Header
} from 'semantic-ui-react';
import _ from 'lodash';
import ModalDetail from '../../opd/_sts/ModalDetail';
import ExportModal from './ExportModal'
import { SingleDatePicker, isInclusivelyBeforeDay } from 'react-dates';
import { isBank, isAdmin, isVerificator } from '../../../../../_utils/localstorage';
import ModalEdit from '../../opd/_sts/ModalEdit';
import DateModalVerif from './DateModalVerif';
import swal from 'sweetalert'
import { toIDR } from '../../../../../_utils/tocurrency';

export default class ValidasiSTS extends Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         data: [],
         direction: null,
         requests: true,
         activePage: 1,
         totalPages: 0,
         itemPerPage: 0,
         totalItem: 0,
         q: "",

         is_detail: false,
         data_detail: null,
         loading_detail: false,

         is_edit: false,
         data_edit: null,
         loading_edit: false,

         is_verif: false,
         data_verif: null,
         loading_verif: false,

         is_export: false,
         isFilter: false,

         focused: null,
         startDate: null,
         endDate: null,
         status: 2,
         focusedInput: null,
         pageActive: 1,
         checkSTSBermasalah: false,
         processing: 0,
         dataLength: 0,
         resultBermasalah: false,
         date: null,
      }

      this.searchSTS = this.searchSTS.bind(this);
      this.onCloseDetail = this.onCloseDetail.bind(this);
      this.onOpenDetail = this.onOpenDetail.bind(this);
      this.onFilter = this.onFilter.bind(this);
      this.onCloseExport = this.onCloseExport.bind(this);
      this.onOpenExport = this.onOpenExport.bind(this);

      this.onCloseVerif = this.onCloseVerif.bind(this);
      this.onOpenVerif = this.onOpenVerif.bind(this);

      this.onRefresh = this.onRefresh.bind(this);
      this.onOpenEdit = this.onOpenEdit.bind(this);
      this.onCloseEdit = this.onCloseEdit.bind(this);
      this.onChangeStatus = this.onChangeStatus.bind(this);
      this.onCheckStatus = this.onCheckStatus.bind(this);
      this.onVerifikasiAdmin = this.onVerifikasiAdmin.bind(this);


   }

   onOpenEdit = (e, { index }) => {
      const { data } = this.state
      this.setState({
         is_edit:true,
         data_edit:data[index],
         loading_edit:false
      });
   }

   onCloseEdit = () => {
      this.onRefresh();
      this.setState({
         is_edit:false,
         data_edit:null
      });
   }

   onRefresh(){
      this.setState({
         startDate: null,
         endDate: null,
         q: "",
         requests: true,
         status: 2
      })

      fetch(`${BaseURLDev}/stsallchecking?date=null`, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({data: [], requests: false});
            swal("Mohon periksa koneksi internet anda", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
      .catch(e => {
         this.setState({requests: false})
         swal("Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
            icon: "error",
         });
      })
   }

   verifikasiUlangSTS(no_sts){
      
      swal({
         title: "Apakah anda yakin?",
         text: "STS ini akan diverifikasi ulang dan langsung divalidasi ke server SIMDA!",
         icon: "warning",
         buttons: true,
         dangerMode: true,
      })
      .then((verif) => {
         if (verif) {
            this.setState({requests:true});
            fetch(`${BaseURLDev}/postsimda/verifikasibpkad`,{
               method: 'POST',
               headers,
               body: JSON.stringify({
                  no_sts: no_sts,
                  date: null
               })
            })
            .then(response => {
               if (!response.ok) { 
                  this.setState({requests:false});
                  swal("Verifikasi STS gagal", {
                     icon: "error",
                  });
                  return Promise.reject(response.statusText);
               }
               return response.json()
            })
            .then(parsedJSON => {
               this.setState({
                  // data:{
                  //    ...this.state.data,
                  //    is_verified: true
                  // },
                  requests: false
               });
               swal("Verifikasi STS selesai", {
                  icon: "success",
               }).then(()=>{
                  window.location.href="/a/sts"
               });
            })
         } else {
            return false
         }
      });
   }

   onFilter(){
      // let { startDate, endDate, status } = this.state
      // const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
      // const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');

      // change value from status bermasalah to terverifikasi
      // if (status == 3) {
      this.setState({checkSTSBermasalah: true});
      // } else {
      //    this.setState({checkSTSBermasalah: false});
      // }
      const date = this.state.date===null ? null : this.state.date.format('YYYY-MM-DD')

      this.setState({ requests: true, isFilter: true, q: "" })
      fetch(`${BaseURLDev}/stsallchecking?date=${date}`, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({data:[],requests:false});
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }

   // verifySTS = async (data, sts) => {
   //    let { bp } = sts;

   //    // compare value from sts object & response simda object
   //    await bp.map((itemBp, i) => {
   //       // console.log(itemBp)
   //       itemBp.rincian.map((rincian, j) => {
   //          // console.log(rincian)
   //          data.data_rincian.map(item => {
   //             if (
   //                 itemBp.tahun == item.tahun
   //                 && itemBp.no_sts == item.no_sts
   //                 && item.kd_rek1 == rincian.kd_rek1
   //                 && item.kd_rek2 == rincian.kd_rek2
   //                 && item.kd_rek3 == rincian.kd_rek3
   //                 && item.kd_rek4 == rincian.kd_rek4
   //                 && item.kd_rek5 == rincian.kd_rek5
   //                //  && item.kd_rekunit5 == rincian.kd_unit5
   //                //  && item.kd_bidang == rincian.kd_bidang
   //                //  && item.kd_sub == rincian.kd_sub
   //                //  && item.kd_urusan == rincian.kd_urusan
   //                //  && item.kd_bidang == rincian.kd_bidang
   //                 && item.nilai == rincian.nilai
   //                 && item.uraian_rinc == rincian.keterangan
   //             ) {
   //                bp[i].rincian[j].checkStatusSimda = true;
   //             }
   //          })
   //       })
   //    });
   //    // send status sts
   //    sts.status_sts = data.status_sts;
   //    // fill sts object with new bp object
   //    sts.bp
   //    await this.setState({
   //       is_detail: true,
   //       data_detail: sts,
   //       loading_detail: false
   //    });
   // };

   // verifyBP = async (data, bp) => {
   //    // if (data.status_bp == false) {
   //    //    return false;
   //    // }
   //    // if (data.data_rincian.length == 0) {
   //    //    return false;
   //    // }

   //    // compare value from bp object & response simda object
   //    let checkCount = 0;
   //    await bp.rincian.map((rincian, j) => {
   //       data.data_rincian.map(item => {
   //          if (
   //              bp.tahun == item.tahun
   //              && item.kd_rek1 == rincian.kd_rek1
   //              && item.kd_rek2 == rincian.kd_rek2
   //              && item.kd_rek3 == rincian.kd_rek3
   //              && item.kd_rek4 == rincian.kd_rek4
   //              && item.kd_rek5 == rincian.kd_rek5
   //              && item.nilai == rincian.nilai
   //              && item.no_bukti == bp.no_bukti
   //          ) {
   //             checkCount++;
   //          }
   //       })
   //    });

   //    if (checkCount < data.data_rincian.length) return false;

   //    return true;
   // };

   // checkDataBPServer =  async (bp) => {
   //    const self = this;
   //    let result = 'invalid';
   //    let public_id = bp.public_id;
   //    let response = await fetch(`${BaseURLDev}/postsimda/check_rincian_bp/${public_id}`, { headers });
   //    let data = await response.json();
   //    self.verifyBP(data, bp)
   //    if (!data.status_bp) result = 'invalid';
   //    else if (!data.data_rincian.length) result = 'invalid';
   //    else result = true;

   //    // console.log(`${bp.no_bukti} = ${result}`, 'result');
   //    return result;
   // };

   // checkSTSList = async (data, sts) => {
   //    let { bp } = sts;
   //    if (data.status_sts == false) {
   //       return false;
   //    }
   //    if (data.data_rincian.length == 0) {
   //       return false;
   //    }
   //    let checkCount = 0;
   //    // await bp.map((itemBp, i) => {
   //    //    itemBp.rincian.map((rincian, j) => {
   //    //       data.data_rincian.map(item => {
   //    //          if (
   //    //              itemBp.tahun == item.tahun
   //    //              && itemBp.no_sts == item.no_sts
   //    //              && item.kd_unit == rincian.kd_unit
   //    //              && item.kd_unit1 == rincian.kd_unit1
   //    //              && item.kd_unit2 == rincian.kd_unit2
   //    //              && item.kd_unit3 == rincian.kd_unit3
   //    //              && item.kd_unit4 == rincian.kd_unit4
   //    //              && item.kd_unit5 == rincian.kd_unit5
   //    //              && item.kd_bidang == rincian.kd_bidang
   //    //              && item.kd_sub == rincian.kd_sub
   //    //              && item.kd_urusan == rincian.kd_urusan
   //    //              && item.kd_bidang == rincian.kd_bidang
   //    //              && item.nilai == rincian.nilai
   //    //              && item.uraian_rinc == rincian.keterangan
   //    //          ) {
   //    //             checkCount++;
   //    //          }
   //    //       })
   //    //    })
   //    // });
   //    //
   //    // if (checkCount < data.data_rincian.length) return false;

   //    return true;
   // };

   // checkRincianSTS = async (sts, status) => {
   //    const self = this;
   //    let result = 'invalid';

   //    let public_id = sts.public_id;
   //    let response = await fetch(`${BaseURLDev}/postsimda/check_rincian_sts/${public_id}`, { headers });
   //    let data = await response.json();
   //    // console.log(data)
   //    if (status == 'detail') {
   //       self.verifySTS(data, sts);
   //    } else {
   //       if (data.status_sts == false) result = 'invalid';
   //       else if (data.data_rincian.length == 0) result = 'invalid';
   //       else result = true;
   //       // result = await self.checkSTSList(data, sts);
   //    }
   //    console.log(` ${sts.no_sts} = ${result}`, 'result');
   //    return result;
   // };

   onOpenDetail = async (e, { index }) => {
      // await this.setState({loading_detail: true});
      // await this.checkRincianSTS(this.state.data[index], 'detail');
      await this.setState({
         is_detail: true,
         data_detail: this.state.data[index],
         loading_detail: false
      })
   };

   onCloseDetail = () => this.setState({is_detail: false, data_detail: null});

   onCloseExport = () => this.setState({is_export: false})
   onOpenExport = () => this.setState({is_export: true})

   onCloseVerif = () => this.setState({is_verif: false, data_verif: null})
   onOpenVerif = (e, {index}) => this.setState({is_verif: true, data_verif: this.state.data[index]})

   handleSort = clickedColumn => () => {
      const { column, data, direction } = this.state

      if (column !== clickedColumn) {
         this.setState({
            column: clickedColumn,
            data: _.sortBy(data, [clickedColumn]),
            direction: 'ascending',
         })

         return
      }

      this.setState({
         data: data.reverse(),
         direction: direction === 'ascending' ? 'descending' : 'ascending',
      })
   }

   onLoadData(){
      const date = this.state.date===null ? null : this.state.date.format('YYYY-MM-DD')
      this.setState({ requests: true });
      fetch(`${BaseURLDev}/stsallchecking?date=${date}`, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({ data: [], requests: true });
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         // this.setState({checkSTSBermasalah: true})
         console.log(resJSON)
         this.defaultState(resJSON)
      })
      .catch(e => {
         swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
            icon: "error",
         });
      })
   }

   defaultState = async (stateData) => {
      console.log(stateData)
      const {checkSTSBermasalah} = this.state;
      this.setState({dataLength: stateData.data.length});

      if (checkSTSBermasalah) {
         let stsBermasalah = [];
         for (let i = 0; i < stateData.data.length; i++) {
            this.setState({processing: i+1});
            stateData.data[i].checkListSimda = await this.checkRincianSTS(stateData.data[i], null);
            // if result is false, then skip, dont check BP
            if (stateData.data[i].checkListSimda == 'invalid') {
               stsBermasalah.push(stateData.data[i]);
               continue;
            }

            for (let j = 0; j < stateData.data[i].bp.length; j++) {
               stateData.data[i].checkListSimda = await this.checkDataBPServer(stateData.data[i].bp[j]);
               // if false, then break the loop, STS is not valid
               if (stateData.data[i].checkListSimda == 'invalid') {
                  stsBermasalah.push(stateData.data[i]);
                  break;
               }
            }
         }

         await this.setState({
            data: stsBermasalah,
            totalPages: stateData.totalPage,
            requests: false,
            totalItem: stateData.totalItem,
            itemPerPage: stateData.itemPerPage,
            isFilter: false,
            processing: 0,
            checkSTSBermasalah: false,
            resultBermasalah: true
         })

      } else {
         await this.setState({
            data: stateData.data,
            totalPages: stateData.totalPage,
            requests: false,
            totalItem: stateData.totalItem,
            itemPerPage: stateData.itemPerPage,
            isFilter: false,
            processing: 0,
            checkSTSBermasalah: false,
            resultBermasalah: false
         })
      }

   };

   componentDidMount(){
      this.onLoadData();
   }

   handlePaginationChange = (e, { activePage }) => {
      if (this.state.pageActive === activePage){
         return false;
      }

      const { startDate, endDate, status } = this.state
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD')

      this.setState({ activePage, pageActive: activePage, requests: true, isFilter: true })
      var url = null;
      if(this.state.q !== ""){
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}&page=${activePage}&q=${this.state.q}`
      }else{
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}&page=${activePage}`
      }

      fetch(url,{ headers })
      .then(response => {
         if(!response.ok){
            this.setState({ data: [], requests: false });
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }

   searchSTS(e) {
      this.setState({ q: e.target.value, requests: true });
      const { startDate, endDate, status } = this.state;
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD');
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');
      var url = null;
      if(e.target.value !== ""){
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}&q=${e.target.value}`
      }else{
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}`
      }

      fetch(url, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({ requests: false });
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }


   onChangeStatus(e, el){
      // change value from status bermasalah to terverifikasi
      if (el.value == 3) {
         this.setState({checkSTSBermasalah: true});
      } else {
         this.setState({checkSTSBermasalah: false});
      }

      this.setState({ status: el.value, requests: true, isFilter: true });
      const { startDate, endDate, q } = this.state;
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD');
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');
      var url = null;
      if(q !== ""){
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${el.value == 3 ? 1 : el.value}&q=${q}`
      }else{
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${el.value == 3 ? 1 : el.value}`
      }

      fetch(url, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({ requests: false });
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }

   onVerifikasiAdmin(e, { index }){
      swal({
         text: "Benar akan diverifikasi?",
         icon: "warning",
         buttons: true,
         dangerMode: true,
       })
      .then((willVerified) => {
         if (willVerified) {
            this.setState({ requests: true });
            fetch(`${BaseURLDev}/postsimda/verifikasiadm/${this.state.data[index].public_id}`,{
               method: 'POST',
               headers,
               body: JSON.stringify({
                  date: null
               })
            })
            .then(response => {
               if (!response.ok) {
                  this.setState({ requests: false });
                  swal("Verifikasi STS ke SIMDA gagal", {
                     icon: "error",
                  });
                  return Promise.reject(response.statusText);
               }
               return response.json()
            })
            .then(parsedJSON => {
               swal("Verifikasi STS ke SIMDA","Verifikasi STS Sukses", "success")
               this.setState({ requests: false });
            })
         }
      });
   }

   checkSTSValid = () => {
      let sts = this.state.data;
      console.log(sts)
   };

   onCheckStatus(e, { index }){
      this.setState({ requests: true });
      fetch(`${BaseURLDev}/postsimda/checkstatus`,{
         method: 'POST',
         headers,
         body: JSON.stringify({
            no_sts: this.state.data[index].no_sts
         })
      })
      .then(response => {
         if (!response.ok) {
            this.setState({ requests: false });
            swal("Validasi STS gagal", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(parsedJSON => {
         const data_json = parsedJSON.data;
         if(data_json.data!==null && data_json.error_network===false && data_json.error_data===false)
            swal("Validasi STS", `STS ${parsedJSON.no_sts} telah terdaftar di database SIMDA dengan Nomor BKU ${data_json.data.no_bku}`,"success")
         else if(data_json.data===null && data_json.error_network===true && data_json.error_data===false)
            swal("Validasi STS", "Maaf Jaringan SIMDA sedang bermasalah", "error")
         else if(data_json.data===null && data_json.error_network===false && data_json.error_data===true)
            swal("Validasi STS", `Maaf STS ${parsedJSON.no_sts} tidak ditemukan di database SIMDA`, "error")

         this.setState({ requests: false });
      })
   }

   render() {
      const { dataLength, processing, column, data, direction, activePage, startDate, endDate, requests, isFilter } = this.state;
      const status_opt = [
         // {'key': 0, 'text': 'Terverifikasi', 'value': 1},
         // {'key': 1, 'text': 'Belum Terverifikasi', 'value': 0},
         // {'key': 2, 'text': 'Semua Status', 'value': 2},
         {'key': 0, 'text': 'STS Bermasalah', 'value': 3},
      ];

      return (
         <div>
            <div>
                  <Menu>
                     {/* {(isAdmin() || isVerificator()) &&
                        <Menu.Item>
                           <Form.Field
                              control={Select}
                              search
                              onChange={this.onChangeStatus}
                              options={status_opt}
                              placeholder='Pilih Status'
                           />
                        </Menu.Item>
                     } */}
                     <Menu.Item>
                        <SingleDatePicker 
                           date={this.state.date}
                           block
                           isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                           onDateChange={(date) => this.setState({ date })}
                           numberOfMonths={1}
                           focused={this.state.focused}
                           onFocusChange={({ focused }) => this.setState({ focused })}
                           id="dateManual"
                           onDatesChange={({ date }) => this.setState({ date })}
                        />
                     </Menu.Item>
                     <Menu.Item>
                        <Button disabled={this.state.date===null || isFilter || requests}
                           color="green" size="small" onClick={this.onFilter}>Periksa Data STS</Button>
                     </Menu.Item>
                     <Menu.Item className="right floated">
                        <Button disabled={true} color="white" size="small">
                           <p style={{color: 'black'}}>
                              {data.length} STS
                           </p>
                        </Button>
                     </Menu.Item>
                  </Menu>
                  {
                     this.state.checkSTSBermasalah ?
                         <Header as='h3' textAlign='center' color='grey'>
                            {processing} dari {dataLength} sedang diproses di SIMDA ...
                         </Header>
                         :
                         null
                  }
                  <Segment loading={(this.state.loading_detail || requests)}>
                     <Table size='small' sortable celled>
                        <Table.Header>
                           <Table.Row>
                              <Table.HeaderCell style={{width:"6%"}}>Proses</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"3%"}}>No.</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"20%"}}>OPD</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"15%"}} sorted={column === 'no_sts' ? direction : null} onClick={this.handleSort('no_sts')}>
                                 Nomor STS
                              </Table.HeaderCell>
                              <Table.HeaderCell style={{width:"6%"}} sorted={column === 'created_at' ? direction : null} onClick={this.handleSort('created_at')}>
                                 Pembuatan
                              </Table.HeaderCell>
                              <Table.HeaderCell style={{width:"6%"}} sorted={column === 'tgl_realisasi' ? direction : null} onClick={this.handleSort('tgl_realisasi')}>
                                 Realisasi
                              </Table.HeaderCell>
                              {/* <Table.HeaderCell style={{width:"20%"}}>Verifikator</Table.HeaderCell> */}
                              <Table.HeaderCell style={{width:"6%"}}>Total BP</Table.HeaderCell>
                              <Table.HeaderCell>Total Nilai</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"30%"}}>Keterangan</Table.HeaderCell>
                           </Table.Row>
                        </Table.Header>
                        <Table.Body>
                           {data.length===0 &&
                              <Table.Row>
                                 <Table.Cell colSpan="9">Data tidak ditemukan</Table.Cell>
                              </Table.Row>}
                              { !this.state.resultBermasalah ?
                                 data.map((item,i) => (
                                    <Table.Row key={i} style={{
                                       "backgroundColor": !item.tgl_realisasi && (isAdmin() || isVerificator()) ? "#f9cecd" : null,
                                    }}>
                                       <Table.Cell>
                                          <Dropdown text='Action' icon='angle down' floating labeled button className='icon'>
                                             <Dropdown.Menu>
                                                <Dropdown.Divider />
                                                <Dropdown.Item icon='align justify' index={i} onClick={this.onOpenDetail} text='Detail' />
                                                {isBank() &&
                                                   <Dropdown.Item icon='pointing up' index={i} onClick={this.onOpenVerif} text='Verifikasi Manual' />
                                                }
                                                {/* {(isAdmin() || isVerificator()) &&
                                                   <Dropdown.Item icon='refresh' index={i} onClick={this.onCheckStatus} text='Cek ke SIMDA' />
                                                } */}
                                                <Dropdown.Divider />
                                             </Dropdown.Menu>
                                          </Dropdown>
                                       </Table.Cell>
                                       <Table.Cell>{i+1+(activePage-1)*10}.</Table.Cell>
                                       <Table.Cell>{item.org_opd.nama}</Table.Cell>
                                       <Table.Cell>{item.no_sts}</Table.Cell>
                                       <Table.Cell>{toDMYDate(item.created_at)}</Table.Cell>
                                       <Table.Cell>
                                          { item.tgl_realisasi ? toDMYDate(item.tgl_realisasi) : "-" }
                                       </Table.Cell>
                                       {/* <Table.Cell>
                                          { item.bank===null ? "-" : item.bank.nama_bank }
                                       </Table.Cell> */}
                                       <Table.Cell>{item.total_bp} BP</Table.Cell>
                                       <Table.Cell>{toIDR(item.total_nilai)}</Table.Cell>
                                       <Table.Cell>{ item.keterangan }</Table.Cell>
                                    </Table.Row>
                                 )) :
                                 data.map((item,i) => (
                                    <Table.Row key={i} style={{
                                       "backgroundColor": "#F8FA42",
                                    }}>
                                       <Table.Cell>
                                          <Dropdown text='Action' icon='angle down' floating labeled button className='icon'>
                                             <Dropdown.Menu>
                                                <Dropdown.Divider />
                                                   <Dropdown.Item icon='align justify' index={i} onClick={this.onOpenDetail} text='Detail' />
                                                   {isBank() &&
                                                      <Dropdown.Item icon='pointing up' index={i} onClick={this.onOpenVerif} text='Verifikasi Manual' />
                                                   }
                                                   {(isAdmin() || isVerificator()) &&
                                                      <Dropdown.Item icon='refresh' index={i} onClick={this.onCheckStatus} text='Cek ke SIMDA' />
                                                   }
                                                   {(isAdmin() || isVerificator()) &&
                                                      <Dropdown.Item icon='refresh' index={i} onClick={() => this.verifikasiUlangSTS(item.no_sts)} text='Verifikasi Ulang' />
                                                   }
                                                <Dropdown.Divider />
                                             </Dropdown.Menu>
                                          </Dropdown>
                                       </Table.Cell>
                                       <Table.Cell>{i+1+(activePage-1)*10}.</Table.Cell>
                                       <Table.Cell>{item.org_opd.nama}</Table.Cell>
                                       <Table.Cell>{item.no_sts}</Table.Cell>
                                       <Table.Cell>{toDMYDate(item.created_at)}</Table.Cell>
                                       <Table.Cell>
                                          {item.tgl_realisasi ?
                                             toDMYDate(item.tgl_realisasi) : "-"
                                          }
                                       </Table.Cell>
                                       <Table.Cell>{item.total_bp} BP</Table.Cell>
                                       <Table.Cell>{toIDR(item.total_nilai)}</Table.Cell>
                                       {/* <Table.Cell>
                                          {item.bank===null ?
                                             "-" :
                                             item.bank.nama_bank
                                          }
                                       </Table.Cell> */}
                                       <Table.Cell>{item.keterangan}</Table.Cell>
                                    </Table.Row>
                                 ))
                           }
                        </Table.Body>
                     </Table>
                  </Segment>
                  {this.state.is_edit &&
                     <ModalEdit
                        open={this.state.is_edit}
                        data_edit={this.state.data_edit}
                        onClose={this.onCloseEdit} />
                  }
                  {this.state.is_detail &&
                     <ModalDetail
                        open={this.state.is_detail}
                        data_detail={this.state.data_detail}
                        onClose={this.onCloseDetail} />
                  }

                  {this.state.is_export &&
                     <ExportModal
                        open={this.state.is_export}
                        onClose={this.onCloseExport}
                        data={this.state.data}
                     />
                  }
                  {this.state.is_verif &&
                     <DateModalVerif
                        open={this.state.is_verif}
                        onClose={this.onCloseVerif}
                        data_verif={this.state.data_verif}
                     />
                  }
               </div>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_sts/ValidasiSTS.js